import React, { useState, useEffect } from 'react';
import { Form, Checkbox, Input, Radio } from 'antd';

interface FormItemProps {
  form: any;
}

const LectureWeekFormItem = ({form}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */


  /* ======================================================
  * hooks
  * ====================================================== */

  /* ======================================================
  * events
  * ====================================================== */  

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <>
      <Form.Item name="repeat_week" style={{ display: 'inline-block', marginRight: '5px' }}>
        <Radio.Group style={{display:"flex"}}>
          <Radio value={0}>없음</Radio>
          <Radio value={1}>매주</Radio>
          <Radio value={2}>격주</Radio>
        </Radio.Group>        
      </Form.Item> 
      <Form.Item name="week_mon" valuePropName="checked" style={{ display: 'inline-block', marginRight: '5px' }}>
        <Checkbox>월</Checkbox>                
      </Form.Item>  
      <Form.Item name="week_tue" valuePropName="checked" style={{ display: 'inline-block', marginRight: '5px' }}>
        <Checkbox>화</Checkbox>                
      </Form.Item>  
      <Form.Item name="week_wed" valuePropName="checked" style={{ display: 'inline-block', marginRight: '5px' }}>
        <Checkbox>수</Checkbox>                
      </Form.Item>  
      <Form.Item name="week_thu" valuePropName="checked" style={{ display: 'inline-block', marginRight: '5px' }}>
        <Checkbox>목</Checkbox>                
      </Form.Item>  
      <Form.Item name="week_fri" valuePropName="checked" style={{ display: 'inline-block', marginRight: '5px' }}>
        <Checkbox>금</Checkbox>                
      </Form.Item>       
    </>
  );
};

export default LectureWeekFormItem;
